import accessibilityMixin from '@/components/mixins/Accessibility.vue'

export default {
    // Gives every render-post component `scrollbarClass` (see Accessibility.vue) for free,
    // instead of wiring the mixin into each of the ~11 postXxx.vue files individually.
    mixins: [accessibilityMixin],
    data() {
        return {
            resizeObserver: null,
            fontSize: 0,
        }
    },
    mounted () {
        // Not every template using this mixin renders a 'render-post' ref (e.g. RenderPostFailed
        // shows an error message instead), so both this and updateFontSize() must guard the ref.
        if (!this.$refs['render-post']) return

        this.resizeObserver = new ResizeObserver(() => {
            this.updateFontSize();
        });
        this.resizeObserver.observe(this.$refs['render-post']);

        this.$nextTick(() => {
            this.updateFontSize();
        })

    },
    methods: {

        updateFontSize() {
            if (!this.$refs['render-post']) return
            this.fontSize = this.$refs['render-post'].offsetWidth / 351;
        },
    },

    beforeDestroy () {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
    }
  };